import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'left',
        padding: '20px',
        borderRadius: '14px !important',
        border: '2px solid #ff6468',
        boxShadow:'none  !important',
        textAlign: 'center',
        backgroundColor: '#fff',
    },
    cardTitle: {
        fontSize: '22px !important',
        fontWeight: 'bold !important',
        marginBottom: '4px !important',
    },
    subtitle: {
        fontSize: '13px',
        marginBottom: '12px',
    },
    description: {
        fontSize: '14px !important',
        lineHeight:'1.1 !important',
        marginTop: '12px !important',
        marginBottom: '12px !important',
        textAlign: 'left !important',
        minHeight:'100px !important',
    },
    bulletList: {
        fontSize: '14px',
        textAlign: 'left',
        paddingLeft: '24px',
        marginBottom: '16px',
    },
    icon: {
        height: '70px',
        marginBottom: '8px',
        objectFit: 'contain',
        alignSelf: 'center',
    },
    button:{
        width: '70%',
        alignSelf: 'center',
        fontWeight: 'bold',
        fontSize: '17px !important',
        borderRadius: '20px !important',
        color:'#fff !important',
        backgroundColor: '#ff6468ff !important',
        '&:hover': {
            backgroundColor: '#ff6468ff !important',
        },
    },
    indicatorCell: {
        transition: 'background-color 0.2s ease',
    },
    textFieldRoot: {
        width: '100%',
        marginBottom:'20px',
        '& .MuiOutlinedInput-root': {
            borderRadius: '20px',
            backgroundColor: '#fff',
            width: '100%',

            '& fieldset': {
                border: '2px solid #ff6468ff',
            },
            '&:hover fieldset': {
                border: '2px solid #ff6468ff',
            },
            '&.Mui-focused fieldset': {
                border: '2px solid #ff6468ff',
            },
        },
        '& .MuiFormLabel-root': {
            color: '#ff6468ff',
        },
        '& .MuiFormLabel-root.Mui-focused': {
            color: '#ff6468ff',
        },
    },
    inputField: {
        marginBottom: theme.spacing(3),
        width: "80%",
        '& .MuiOutlinedInput-root': {
            borderRadius: '5px',
            backgroundColor: '#fff',
            '& fieldset': {
                border: '2px solid #ff6468ff',
            },
            '&:hover fieldset': {
                border: '2px solid #ff6468ff',
            },
            '&.Mui-focused fieldset': {
                border: '2px solid #ff6468ff',
            },
        },
        '& .MuiInputLabel-root': {
            color: '#ff6468ff',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#ff6468ff',
        },

    },
    languageInputField: {
        marginBottom: theme.spacing(3),
        width: "95%",
        '& .MuiOutlinedInput-root': {
            borderRadius: '5px',
            backgroundColor: '#fff',
            '& fieldset': {
                border: '2px solid #ff6468ff',
            },
            '&:hover fieldset': {
                border: '2px solid #ff6468ff',
            },
            '&.Mui-focused fieldset': {
                border: '2px solid #ff6468ff',
            },
        },
        '& .MuiInputLabel-root': {
            color: '#ff6468ff',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#ff6468ff',
        },

    },
    autoCompField:{
        width: "100%",
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                border: '2px solid #ff6468ff',
            },
            '&:hover fieldset': {
                border: '2px solid #ff6468ff',
            },
            '&.Mui-focused fieldset': {
                border: '2px solid #ff6468ff',
            },
        },
        '& .MuiInputLabel-root': {
            color: '#929EA7',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#ff6468ff',
        },
    },

}));

export default useStyles;